'use strict';

import React, { Component } from 'react'

import { MarkerClusterer } from '@googlemaps/markerclusterer'

import Loader from '@Pure/Loader'

import _ from 'lodash'

const moment = window.moment;

moment.locale('fr');

const numeral = window.numeral;

numeral.locale('en');

const google = window.google;

const app = window.app;

export default class PartnersMap extends Component
{
	state =
	{
		gmap_id: ++app.gmap_id
	};

	markers = [];

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'documentResized',
			type: 'listener',
			cb: component.startMapIfNeeded
		});

		component.startMapIfNeeded();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'documentResized',
			type: 'listener',
			cb: component.startMapIfNeeded
		});
	}

	startMapIfNeeded = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (component.map) return;

		const map_div = document.getElementById('gmap-' + component.state.gmap_id);

		component.map = new google.maps.Map(map_div,
		{
			zoom: 7,
			center: { lat: 43.597748, lng: -2.419812 }, // South of France
			gestureHandling: 'cooperative'
		});

		component.placeMarkers();
	}

	placeMarkers = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (!props.geocodings || !component.map) return;

		props.geocodings.forEach(function (geocoding)
		{
			let marker = component.markers[geocoding.id], id = geocoding.id;

			if (!marker)
			{
				let position = geocoding.data.position || geocoding.data;

				if (typeof position === 'string')
				{
					position = position
					.replace('(', '')
					.replace(')', '')
					.split(', ');

					position = new google.maps.LatLng(position[0], position[1]);
				}
				else if (position && position.lat && position.lng)
				{
					position = new google.maps.LatLng(position.lat, position.lng);
				}
				else
				{
					return console
					.error('Invalid marker position', geocoding.data.position);
				}

				marker =
				{
					visible: true,

					marker: new google.maps.Marker(
					{
						position: position,
						map: component.map,
						title: geocoding.partners.reduce(function (title, partner)
						{
							if (title !== '') title += ', ';

							title += partner.name;

							return title;
						}, '')
					})
				};
			}
			else if (geocoding.visible === false && marker.visible === true)
			{
				marker.visible = false;

				marker.marker.setMap(null);
			}
			else if (geocoding.visible === true && marker.visible === false)
			{
				marker.visible = true;

				marker.marker.setMap(component.map);
			}

		/**
		 * One tooltip for each partner to allow
		 * displaying multiple tooltips at a time
		 * One tooltip with every partner in it can web used aswell (tooltips[0])
		**/
			if (!marker.tooltips && geocoding.partners.length > 0)
			{
				marker.tooltips = geocoding.partners.map(function (partner)
				{
					let tooltip = { open: false };

					let content =
					(
						'<div className="c-gmap__tooltip">' +
							partner.name +
						'</div>'
					);

					tooltip.infowindow = new google.maps.InfoWindow(
					{
						content: content
					});

					return tooltip;
				});

			// First tooltip regroup every partner
				if (marker.tooltips.length > 1)
				{
					let grouped_tooltip = { open: false };

					let partners_string = geocoding.partners.reduce(function (title, partner)
					{
						if (title !== '') title += ' <br />';

						title += partner.name;

						return title;
					}, '')

					let content =
					(
						'<div className="c-gmap__tooltip">' +
							partners_string +
						'</div>'
					);

					grouped_tooltip.infowindow = new google.maps.InfoWindow(
					{
						content: content
					});

					marker.tooltips.unshift(grouped_tooltip);
				}

				if (!component.markers[id])
				{
					marker.marker.addListener('click', function ()
					{
						let global_tooltip = marker.tooltips[0];

						global_tooltip.infowindow.open(component.map, component.markers[id].marker);
					});
				}
			}

			component.markers[id] = marker;
		});

		new MarkerClusterer(
		{
			markers: Object.keys(component.markers)
			.filter(id => component.markers[id]?.marker)
			.map(id => component.markers[id].marker),

			map: component.map
		});
	}

	componentDidUpdate ()
	{
		const component = this, props = this.props, state = this.state;

		component.placeMarkers();
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
		)
		: undefined;

		var output =
		(
			<div className="c-gmap c-gmap--partners"
				id={ 'gmap-' + state.gmap_id }
			/>
		);

		return output;
	}
}